import * as repo from "../repositories/adjustmentRepository.js";
import { logError } from "../../../shared/utils/logger.js";

export const getAdjustmentsByJobId = async (jobId) => {
  try {
    const res = await repo.fetchAdjustmentsByJobId(jobId);
    if (!res.success) throw new Error(res.error || "Failed to load adjustments");
    return { success: true, data: res.data };
  } catch (error) {
    logError("getAdjustmentsByJobId", { jobId, error: error.message });
    return { success: false, error: error.message, data: [] };
  }
};

export const createAdjustment = async (jobId, data) => {
  try {
    const res = await repo.createAdjustment(jobId, data);
    if (!res.success) throw new Error(res.error || "Failed to create adjustment");
    return { success: true, data: res.data };
  } catch (error) {
    logError("createAdjustment", { jobId, error: error.message });
    return { success: false, error: error.message };
  }
};

export const previewAdjustmentProviderEmail = async (jobId, adjustmentId) => {
  try {
    const res = await repo.fetchAdjustmentProviderEmailPreview(jobId, adjustmentId);
    if (!res.success) throw new Error(res.error || "Failed to load provider email preview");
    return { success: true, data: res.data };
  } catch (error) {
    logError("previewAdjustmentProviderEmail", { jobId, adjustmentId, error: error.message });
    return { success: false, error: error.message };
  }
};

export const approveAdjustment = async (jobId, adjustmentId, approvedBy, options = {}) => {
  try {
    const res = await repo.updateAdjustmentStatus(jobId, adjustmentId, {
      status: "approved",
      approvedBy,
      ...(options.emailContent ? { emailContent: options.emailContent } : {}),
    });
    if (!res.success) throw new Error(res.error || "Failed to approve adjustment");
    return { success: true, data: res.data };
  } catch (error) {
    logError("approveAdjustment", { jobId, adjustmentId, error: error.message });
    return { success: false, error: error.message };
  }
};

export const rejectAdjustment = async (jobId, adjustmentId, approvedBy) => {
  try {
    const res = await repo.updateAdjustmentStatus(jobId, adjustmentId, {
      status: "rejected",
      approvedBy,
    });
    if (!res.success) throw new Error(res.error || "Failed to reject adjustment");
    return { success: true, data: res.data };
  } catch (error) {
    logError("rejectAdjustment", { jobId, adjustmentId, error: error.message });
    return { success: false, error: error.message };
  }
};
